import {CommonModule} from "@angular/common";
import {ChangeDetectionStrategy, Component, Inject, Input, TrackByFunction} from '@angular/core';
import {SidenavComponent} from '../../sidenav/sidenav.component';
import {MatListModule} from '@angular/material/list';
import {MenuItemComponent} from '../menu-item/menu-item.component';
import {IMenu, IMenuItem} from 'src/app/core/models/menu.model';
import {SignalStore} from 'src/app/shared/functions/store.functions';
import {AppState} from 'src/app/core/models/app.model';

@Component({
  selector: 'app-menu-panel',
  standalone: true,
  imports: [
    CommonModule,
    MatListModule,
    SidenavComponent,
    MenuItemComponent
  ],
  templateUrl: './menu-panel.component.html',
  styleUrl: './menu-panel.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuPanelComponent {
  @Input() title: string = 'menu';
  @Input() menu?: IMenu;
  readonly author = this.appStore.selectKey('author');
  readonly version = this.appStore.selectKey('version');

  constructor(
    @Inject('app-store') public readonly appStore: SignalStore<AppState>,
  ) {
  }

  trackByMenuItem: TrackByFunction<IMenuItem> = (index, menuItem) => menuItem.name;
}
